// extracted by mini-css-extract-plugin
module.exports = {"editTrigger":"_0f472a6c1207713b6d19f35a2f41b11f-less"};